module.exports = __webpack_public_path__ + "img/fighter-jet.792c51be.svg";